<div class="student-container">
  <student-details [student]="student"></student-details>
  <div class="student-actions">
    <p class="student-name">Actions</p>
    <br />
    <button
      (click)="this.openTransferStudentDialog(this.student)"
      mat-stroked-button
      class="transfer"
    >
      <mat-icon>groups</mat-icon>
      Transfer
    </button>
    <br />
    <br />
    <button
      (click)="this.openSuspensionDialog(this.student)"
      mat-stroked-button
      class="sus"
      *ngIf="!this.student.isSuspended"
    >
      <mat-icon>block</mat-icon>
      Suspend
    </button>
    <button
      (click)="this.activateAccount()"
      [disabled]="this.isLoading"
      mat-stroked-button
      class="sus"
      *ngIf="this.student.isSuspended"
    >
      <mat-icon>refresh</mat-icon>Activate
    </button>
  </div>
  <div class="student-actions">
    <br />
    <br />
    <button
      (click)="this.resetDevices()"
      [disabled]="this.isLoading"
      mat-stroked-button
      class="reset"
      *ngIf="this.student.devices && this.student.devices.length != 0"
    >
      <mat-icon>lock_reset</mat-icon>Reset Devices
    </button>
    <br *ngIf="this.student.devices && this.student.devices.length != 0" />
    <br *ngIf="this.student.devices && this.student.devices.length != 0" />
    <button
      (click)="this.resetPassword()"
      [disabled]="this.isLoading"
      mat-stroked-button
      class="password"
      *ngIf="!this.student.isSuspended"
    >
      <mat-icon>password</mat-icon>Reset Password
    </button>
    <br />
    <br />
    <button
      (click)="this.openScheduleDialog()"
      mat-stroked-button
      class="schedule"
    >
      <mat-icon>today</mat-icon>Schedule
    </button>
    <br />
    <br />
    <button (click)="this.goToIssues()" mat-stroked-button color="white">
      <mat-icon>priority_high</mat-icon>Checklist
    </button>
    <br />
    <br />
    <button class="transfer" mat-stroked-button (click)="this.goToProfile()">
      <mat-icon>perm_identity</mat-icon>
      Student Profile
    </button>
  </div>
</div>
